import * as React from "react";
import { Grid, withStyles } from '@material-ui/core';

interface TrailerFieldsProps {
  classes: Record<string, string>;
  label: string;
  value?: string | null;
  isSelectedValue?: boolean;
}

const styles = (theme: any) => ({
  label: {
    color: theme.iconColor,
    fontSize: theme.textFontSize,
    fontWeight: 400,
    lineHeight: 'normal'
  },
  value: {
    color: theme.TextColor,
    fontSize: theme.textFontSize,
    fontWeight: 600,
    lineHeight: 'normal'
  },
  blueValue: {
    color: theme.HeaderSelectedText,
    fontSize: theme.textFontSize,
    fontWeight: 600,
    lineHeight: 'normal'
  }
});

const TrailerFields = ({ classes, label, value, isSelectedValue }: TrailerFieldsProps) => {
  return (
    <Grid item xs={12} md={2}>
      <div className={classes.label}>{label}</div>
      <div className={isSelectedValue ? classes.blueValue : classes.value}>{value || '-'}</div>
    </Grid>
  );
};

export default withStyles(styles)(TrailerFields);
